import React, { FC, useCallback } from 'react';
import { Select } from '@src/atoms/Select';
import type { ILegoElemSelect } from '../models';
import { useLegoFormContext } from '../../_FormProvider/useLegoFormContext';
import { MultiValue, SingleValue } from 'react-select';
import { IOptionBase } from '@src/atoms/Select/models';
import { useLoadOptions } from '@src/hooks/useLoadOptions';
import { AnyType } from '@src/models/common';
import type { ILegoElemProps } from '../../Lego';
import { findCurrValue, findCurrValueList } from './utils';

// todo: Убрать интерфейсы и пр. от react-select-а на выходных данных от нашего селекта
export const LegoElemSelect: FC<ILegoElemProps> = ({ elem, loading, dependsEntries, errorMessage }) => {
  const legoElem = elem as ILegoElemSelect;
  const { formHook } = useLegoFormContext();
  const value = formHook.watch(elem.id);

  const loadedOptions = useLoadOptions(legoElem, dependsEntries);

  const finallyOptions = loadedOptions || legoElem.select.options || [];
  // Группируем, если группировка в принципе есть
  const isGroupedOptions = finallyOptions && finallyOptions.length > 0 && !!(finallyOptions[0] as AnyType).groupName;

  // Считаем выбранное значение в селекте
  const selectValue = legoElem.select.isMulti
    ? findCurrValueList(finallyOptions as AnyType[], value)
    : findCurrValue(finallyOptions as AnyType[], value);

  const handleOnChange = useCallback(
    (newValue: MultiValue<IOptionBase> | SingleValue<IOptionBase>) => {
      if (legoElem.select.isMulti) {
        const multiValue = newValue as MultiValue<IOptionBase>;
        const values = Array.isArray(multiValue)
          ? multiValue?.map((item) => {
              return item?.value;
            })
          : newValue;
        formHook.setValueAndRevalidate(elem.id, values);
      } else {
        const singleValue = newValue as SingleValue<IOptionBase>;
        formHook.setValueAndRevalidate(elem.id, singleValue?.value);

        if (legoElem.select.addLabelIntoValue) {
          // Спец костыль. Читай описание
          formHook.setValueAndRevalidate(legoElem.select.addLabelIntoValue, singleValue?.label);
        }
      }
    },
    [elem.id, formHook, legoElem.select.addLabelIntoValue, legoElem.select.isMulti],
  );

  const handleNoOptionsMessage = useCallback(() => {
    // Когда в селекте нечего выводить в список в дропдаун - в него выводится это сообщение
    return 'Список пустой';
  }, []);

  // todo: Сделать Select как Input или Textarea, чтобы подключался стандартно
  // TODO: удалить @ts-ignore после удаления строго Select`а
  return (
    <Select
      id={elem.id}
      value={selectValue}
      onChange={handleOnChange}
      isGroupedOptions={isGroupedOptions}
      {...legoElem.select}
      options={finallyOptions}
      isHelpMessage
      errorMessage={errorMessage}
      noOptionsMessage={handleNoOptionsMessage}
      disabled={legoElem.select.disabled || loading}
    />
  );
};
